<template>
  <default>

    <section v-if="store.selectedProject" class="bg-coolGray-50 py-4">
      <div class="container px-4 mx-auto">
        <div
            class="p-6 h-full border border-coolGray-100 overflow-hidden bg-white dark:bg-gray-900 rounded-md shadow-dashboard dark:text-white">

          <!--          SPACE START-->
          <div v-if="store.mongoUser.spaceIds.includes(this.store.selectedProject.spaceId)">
            <div class="pb-6 border-b border-coolGray-100">
              <div class="flex flex-wrap items-center justify-between -m-2">
                <div class="w-full md:w-auto p-2">
                  <h2 class="text-coolGray-900 text-2xl font-semibold">{{ store.selectedProject.spaceName }}</h2>
                </div>
              </div>
            </div>
            <!--            VYTVOŘENÍ ÚČTU-->
            <div class="py-6 border-b border-coolGray-100">
              <div class="w-full md:w-9/12">
                <div class="flex flex-wrap -m-3">
                  <div class="w-full md:w-1/3 p-3">
                    <p class="text-sm text-coolGray-800 font-semibold">vytvoření účtu</p>
                  </div>
                  <div class="w-full md:w-2/3 p-3">
                    <create-account-form></create-account-form>
                  </div>
                </div>
              </div>
            </div>
            <!--            VYTVOŘENÍ PROJEKTU-->
            <div class="py-6 border-b border-coolGray-100">
              <div class="w-full md:w-9/12">
                <div class="flex flex-wrap -m-3">
                  <div class="w-full md:w-1/3 p-3">
                    <p class="text-sm text-coolGray-800 font-semibold">Vytvoření projektu</p>
                  </div>
                  <div class="w-full md:flex-1 p-3">
                    <create-project-form></create-project-form>
                  </div>
                </div>
              </div>
            </div>
            <!--            UŽIVATELÉ S PŘÍSTUPEM DO SPACE-->
            <div class="py-6 border-b border-coolGray-100">
              <div class="w-full md:w-9/12">
                <div class="flex flex-wrap -m-3">
                  <div class="w-full md:w-1/3 p-3">
                    <p class="text-sm text-coolGray-800 font-semibold">Uživatelé</p>
                  </div>
                  <div class="w-full md:flex-1 p-3">
                    <table class="table-auto w-full my-4">
                      <thead class="bg-gray-50 border-b">
                      <tr class="text-xs text-gray-500 text-left ">
                        <th class="flex items-center pl-6 py-4 font-bold">
                          email
                        </th>
                        <th class="py-4 font-bold">přístup</th>
                        <th class="py-4 font-bold">#</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr class="border-b border-blue-50" v-for="user in this.store.selectedProject.users">
                        <td class="flex items-center py-4 px-6 font-medium"
                            v-if="user.access === 'space'">
                          <p class="text-sm font-medium">{{ user.email }}</p>
                        </td>
                        <td class="font-medium"
                            v-if="user.access === 'space'">
                          <p class="text-xs text-gray-500">{{ user.access }}</p>
                        </td>
                        <td class="pr-6"
                            v-if="user.access === 'space'">
                          <p class="text-sm font-medium text-red-500 cursor-pointer"
                             v-on:click="removeUser(user)"
                             v-if="user.email !== store.user.email">Odebrat</p>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <!--            PŘIDAT UŽIVATELE DO SPACE-->
            <div class="py-6 border-b border-coolGray-100">
              <div class="w-full md:w-9/12">
                <div class="flex flex-wrap -m-3">
                  <div class="w-full md:w-1/3 p-3">
                    <p class="text-sm text-coolGray-800 font-semibold">Přidat uživatele do daného space</p>
                  </div>
                  <div class="w-full md:flex-1 p-3">
                    <!--      přidání usera do účtu-->
                    <form class="mt-3" @submit.prevent="addUserToSpace">
                      <input v-model="email" class="w-full lg:w-4/5 rounded mr-2" name="email" type="email"
                             placeholder="email"
                             required>
                      <input type="submit"
                             class="my-2 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                             value="přidat">
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <!--            PROJEKTY-->
            <div class="py-6 border-b border-coolGray-100">
              <div class="w-full md:w-9/12">
                <div class="flex flex-wrap -m-3">
                  <div class="w-full md:w-1/3 p-3">
                    <p class="text-sm text-coolGray-800 font-semibold">Projekty</p>
                  </div>
                  <div class="w-full md:flex-1 p-3">
                    <table class="table-auto w-full my-4">
                      <thead class="bg-gray-50 border-b">
                      <tr class="text-xs text-gray-500 text-left ">
                        <th class="flex items-center pl-6 py-4 font-bold">
                          název
                        </th>
                        <th class="py-4 font-bold">#</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr class="border-b border-blue-50" v-for="project in projects">
                        <td class="flex items-center py-4 px-6 font-medium">
                          <p class="text-sm font-medium">{{ project.name }}</p>
                        </td>
                        <td class="pr-6">
                          <p class="text-sm font-medium text-red-500 cursor-pointer"
                             v-if="projects.length > 1"
                             v-on:click="deleteProject(project._id)">Smazat</p>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--          SPACE END-->

          <!--          PROJECT START-->
          <div class="py-6 border-b border-coolGray-100">
            <div class="flex flex-wrap items-center justify-between -m-2">
              <div class="w-full md:w-auto p-2">
                <h2 class="text-coolGray-900 text-2xl font-semibold">{{ store.selectedProject.name }}</h2>
              </div>
            </div>
          </div>
          <!--          UŽIVATELÉ S PŘÍSTUPEM DO PROJEKTU-->
          <div class="py-6 border-b border-coolGray-100">
            <div class="w-full md:w-9/12">
              <div class="flex flex-wrap -m-3">
                <div class="w-full md:w-1/3 p-3">
                  <p class="text-sm text-coolGray-800 font-semibold">Uživatelé</p>
                </div>
                <div class="w-full md:flex-1 p-3">
                  <table class="table-auto w-full my-4">
                    <thead class="bg-gray-50 border-b">
                    <tr class="text-xs text-gray-500 text-left ">
                      <th class="flex items-center pl-6 py-4 font-bold">
                        email
                      </th>
                      <th class="py-4 font-bold">přístup</th>
                      <th class="py-4 font-bold">#</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="border-b border-blue-50" v-for="user in this.store.selectedProject.users">
                      <td class="flex items-center py-4 px-6 font-medium">
                        <p class="text-sm font-medium">{{ user.email }}</p>
                      </td>
                      <td class="font-medium">
                        <p class="text-xs text-gray-500">{{ user.access }}</p>
                      </td>
                      <td class="pr-6">
                        <p class="text-sm font-medium text-red-500 cursor-pointer"
                           v-on:click="removeUser(user)"
                           v-if="user.email !== store.user.email">odebrat</p>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <!--          PŘIDAT UŽIVATELE DO PROJEKTU-->
          <div class="py-6 border-b border-coolGray-100">
            <div class="w-full md:w-9/12">
              <div class="flex flex-wrap -m-3">
                <div class="w-full md:w-1/3 p-3">
                  <p class="text-sm text-coolGray-800 font-semibold">Přidat uživatele do projektu</p>
                </div>
                <div class="w-full md:flex-1 p-3">
                  <!--      přidání usera do projektu-->
                  <form @submit.prevent="addUserToProject" class="mt-3">
                    <input v-model="clientToProject.email"
                           type="email"
                           placeholder="email"
                           name="email"
                           class="rounded mr-2 w-full lg:w-2/5"
                           required>
                    <select v-model="clientToProject.project"
                            required
                            class="rounded mr-2 w-full lg:w-2/5">
                      <option :value="project._id" v-for="project in projects">
                        {{ project.name }}
                      </option>
                    </select>
                    <input type="submit" value="přidat"
                           class="my-2 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
                  </form>
                </div>
              </div>
            </div>
          </div>

          <!--          PROJECT END-->

        </div>
      </div>
    </section>
  </default>
</template>

<script>
import Default from "@/layouts/admin/default.vue";
import CreateAccountForm from "@/components/forms/createAccountForm.vue";
import CreateProjectForm from "@/components/forms/createProjectForm.vue";
import {useAuth0} from "@auth0/auth0-vue";
import {useNotificationStore} from "@/stores/notificationStore";
import {useAppStore} from "@/stores/appStore"

export default {
  name: "SpravceUctuView",
  components: {CreateProjectForm, CreateAccountForm, Default},
  data() {
    const store = useAppStore()
    return {
      store: store,
      notificationStore: useNotificationStore(),
      users: null,
      email: "",
      clientToProject: {
        email: "",
        project: null,
      }
    }
  },
  methods: {
    useAuth0,

    async addUserToSpace() {

      const partialUser = {
        email: this.email,
      };

      const space = await this.$spacesApi.addUserToSpace(this.store.selectedProject.spaceId, partialUser).then(response => {
        return response.data;
      }).catch(e => {
        console.log(e);
      });
      if (space) {
        //update projektu s přidaným userem
        this.store.projects = await this.$usersApi.getUsersProjects().then(response=> response.data);
        this.store.selectedProject.users = this.store.projects.filter(project => project._id === this.store.selectedProject._id)[0].users;
        this.notificationStore.success('klient byl přidán do účtu');

      } else {
        this.notificationStore.error('Uživatel s emailem:' + this.email + ' neexistuje');
      }
      this.email = "";
    },
    async addUserToProject() {
      console.log(this.clientToProject);
      await this.$projectsApi.addUserToProject(
          this.store.selectedProject.spaceId,
          this.clientToProject.project,
          {email: this.clientToProject.email},
      ).then(response => {
        console.log(response.data);
        this.notificationStore.success("klient byl přidán do projektu");
        this.clientToProject.email = "";
        const projectToAddUser = this.store.projects.filter(project => project._id === this.clientToProject.project);
        if(projectToAddUser.length === 1){
          response.data.access = 'project';
          projectToAddUser[0].users.push(response.data);
        }
        this.clientToProject.project = this.store.selectedProject._id;
      }).catch(e => {
        console.log(e)
        this.notificationStore.error("něco se nepovedlo, zkuste to znovu později.");
      });
    },
    async removeUser(user) {
      if (user.access === 'space') {
        await this.$spacesApi.removeUserFromSpace(this.store.selectedProject.spaceId, user._id).then(response => {
          this.notificationStore.success("klient byl z účtu odstraněn")
          this.store.selectedProject.users = this.store.selectedProject.users.filter(u => u._id !== user._id);
        }).catch(e => {
          console.log(e);
        });
      } else if (user.access === 'project') {
        const response = await this.$projectsApi.removeUserFromProject(this.store.selectedProject.spaceId, this.store.selectedProject._id, user._id).then(response => {
          this.notificationStore.success("klient byl z projektu odstraněn")
          this.store.selectedProject.users = this.store.selectedProject.users.filter(u => u._id !== user._id);
          return response.data;
        }).catch(e => {
          console.log(e);
        });
      }
    },
    async deleteProject(projectID) {
      if (!confirm("Opravdu smazat projekt?")) {
        return;
      }
      const response = await this.$projectsApi.removeProject(this.store.selectedProject.spaceId, projectID).then(response => {
        return response.data;
      }).catch(e => console.log(e));
      if (response) {
        this.notificationStore.success("projekt byl odstraněn");
        this.store.projects = await this.$usersApi.getUsersProjects().then(response => {
          console.log(response.data);
          return response.data;
        }).catch(e => {
          console.log(e);
        });
      } else {
        this.notificationStore.error("něco se nepovedlo");
      }
    },
  },
  mounted() {
    this.clientToProject.project = this.store.selectedProject._id;
  },
  async created() {
    //získání apiClienta
    this.notificationStore.notify = this.$notify;
    try {
    } catch (e) {
      console.log(e);
    }
  },
  computed: {
    projects() {
      return this.store.projects.filter(project => project.spaceId === this.store.selectedProject.spaceId);
    }
  }
}
</script>

<style scoped>

</style>